import React, {useMemo} from "react";
import {StartActionType} from "../index";
import {Link, useLocation} from "react-router-dom";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import {matchPath} from "react-router";
import {Dashboard, DashboardOutlined} from "@mui/icons-material";
import {Breakpoint, Theme, useMediaQuery} from "@mui/material";
import useAccessLevels from "../../../../hooks/use-access-levels";
import {useTranslation} from "react-i18next";

const buttonBreakpoint = 'xl';

const useDashboardStartAction = (breakpoint: Breakpoint | number): (StartActionType | null) => {
    const location = useLocation();
    const match = useMemo(() => matchPath(location.pathname, [routes.analytics.dashboards]) && location.pathname !== routes.landing, [location.pathname])
    const iconButton = useMediaQuery<Theme>((theme) => theme.breakpoints.between(breakpoint, buttonBreakpoint));
    const operatorAccessLevels = useAccessLevels();
    const {t} = useTranslation("components", {keyPrefix: 'panel-sections.app-bar.actions.start-action-buttons'});


    return useMemo<StartActionType | null>(() =>
            !(operatorAccessLevels.packages.dashboard.systemWideDashboards || operatorAccessLevels.packages.dashboard.viewDashboards)
                ? null
                : ({
                    key: 'dashboard',
                    title: t(t => t.dashboards),
                    color: "primary" as any,
                    icon: match ? <Dashboard/> : <DashboardOutlined/>,
                    sx: {
                        '&:hover': {
                            color: match ? 'primary.contrastText' : 'primary.main',
                            backgroundColor: match ? 'primary.main' : 'transparent',
                        },
                        ' &:focus': {
                            color: match ? 'primary.contrastText' : 'primary.main',
                            backgroundColor: match ? 'primary.main' : 'transparent',
                        },
                        ...(iconButton && {
                            backgroundColor: match ? 'primary.main' : 'background.paper',
                            color: match ? 'primary.contrastText' : 'primary.main',
                            '&:hover, &:focus': {
                                color: match ? 'primary.contrastText' : 'primary.main',
                                backgroundColor: match ? 'primary.main' : theme => `rgba(${theme.palette.primary.mainChannel} / ${theme.palette.action.hoverOpacity})`,
                            },
                        })
                    },
                    component: Link as any,
                    to: operatorAccessLevels.packages.dashboard.viewDashboards ? routes.analytics.dashboards : routes.analytics.systemDashboards,
                    breakpoint: breakpoint,
                    buttonBreakpoint: 'xl',
                    variant: match ? 'contained' : 'outlined',
                }),
        [operatorAccessLevels.packages.dashboard.systemWideDashboards, operatorAccessLevels.packages.dashboard.viewDashboards, t, match, iconButton, breakpoint])
}

export default useDashboardStartAction;
